import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { CountdownClock } from './CountdownClock';
import { CtaButton } from './CtaButton';
import { includedItems, PRICE, TOTAL_VALUE, SAVINGS, BUNDLE_MOCKUP } from '../data/offer';
export function Offer() {
  return <section id="offer" className="w-full scroll-mt-6 bg-white" aria-labelledby="offer-heading" data-id="element-164" data-mp="1hqippadw6qr1">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-165" data-mp="ozrzlonc03op">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-[1fr_1.15fr] lg:gap-16" data-id="element-166" data-mp="p1l530m7khv4">
          <div data-id="element-167" data-mp="13ym0be3lyuyc">
            <SectionLabel data-id="element-168" data-mp="13yc6fffg03nd">Flash sale — limited time</SectionLabel>

            <h2 id="offer-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.5rem]" data-id="element-169" data-mp="ywwldnd9lx4z">
              This price disappears in
            </h2>

            <div className="mt-6 sm:mt-8" data-id="element-170" data-mp="2af7kyss9o1uv">
              <CountdownClock size="lg" data-id="element-171" data-mp="pl0cjtutzudv" />
            </div>

            <p className="mt-5 max-w-md text-sm leading-relaxed text-muted sm:mt-6" data-id="element-172" data-mp="pml73jh5bdbq">
              The offer ends when the timer hits zero. After that, the bundle
              returns to its full $292 value.
            </p>

            <div className="mt-8 border border-line bg-cream p-4 sm:mt-10 sm:p-5" data-id="element-173" data-mp="13ki8quagi9x9">
              <div className="flex items-end justify-between gap-4" data-id="element-174" data-mp="6tpsnwniwhvh">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-terracotta-dark" data-id="element-175" data-mp="6vk9ayrrhntr">
                  Limited availability — today only
                </p>
                <p className="font-display text-2xl font-semibold leading-none text-ink" data-id="element-176" data-mp="ftm9jc3o8cfz">
                  68%
                </p>
              </div>
              <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-sand" role="img" aria-label="68 percent of flash-sale spots claimed" data-id="element-177" data-mp="3k8m06s101z1i">
                <div className="h-full w-[68%] rounded-full bg-terracotta" data-id="element-178" data-mp="vfh2s2axujgp" />
              </div>
              <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-179" data-mp="qgxfnyklz1mr">
                Claimed
              </p>
            </div>

            <img src={BUNDLE_MOCKUP} alt="Everything included in the bundle: the 30-day method on tablet and phone with the five bonus guides" className="mx-auto mt-8 w-full max-w-[15rem] sm:mt-10 sm:max-w-xs lg:max-w-sm" data-id="element-180" data-mp="154qx7ot98e7z" />
          </div>

          <div className="border border-terracotta/30 bg-cream" data-id="element-181" data-mp="7jcv33ovmp7y">
            <div className="border-b border-terracotta/20 bg-terracotta-soft px-5 py-3.5 sm:px-8 sm:py-4" data-id="element-182" data-mp="lht8tel5pfzl">
              <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-terracotta-dark sm:text-[11px] sm:tracking-[0.16em]" data-id="element-183" data-mp="hewkd78xqpnq">
                The Perfect Dog Method™ — Complete bundle
              </p>
            </div>

            <div className="px-5 py-7 sm:px-8 sm:py-10" data-id="element-184" data-mp="1suv362tx0q25">
              <h3 className="font-display text-xl font-semibold leading-tight text-ink sm:text-3xl" data-id="element-185" data-mp="20ee07czzujtq">
                30-Day System + 5 Free Bonuses
              </h3>

              <p className="mt-6 text-[10px] font-bold uppercase tracking-[0.16em] text-muted sm:mt-8 sm:text-[11px] sm:tracking-[0.18em]" data-id="element-186" data-mp="1qghi218n2om4">
                What’s included
              </p>
              <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 sm:gap-3" data-id="element-187" data-mp="1vhduj3723j35">
                {includedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-188" data-mp="2o3yjjx027j3j">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-189" data-mp="2o62nug1vek4c" />
                    <span className="text-sm leading-snug text-ink/85" data-id="element-190" data-mp="2ed3yux2gork7">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-line pt-7 sm:mt-9 sm:pt-8" data-id="element-191" data-mp="36vrf9z6ijiey">
                <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-muted sm:text-[11px] sm:tracking-[0.16em]" data-id="element-192" data-mp="1j6xnzfb18d0p">
                  Total value: ${TOTAL_VALUE}
                </p>

                <div className="mt-3 flex items-end gap-3 sm:mt-4 sm:gap-4" data-id="element-193" data-mp="197yrsw7ge9ul">
                  <span className="font-display text-5xl font-semibold leading-none tracking-[-0.03em] text-ink sm:text-7xl" data-id="element-194" data-mp="19a1lbq7tel42">
                    ${PRICE}
                  </span>
                  <span className="pb-2 font-display text-2xl text-muted line-through" data-id="element-195" data-mp="21w4dbl6c02vh">
                    ${TOTAL_VALUE}
                  </span>
                </div>

                <p className="mt-5 inline-block rounded-full border border-moss/30 bg-moss-soft px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.12em] text-moss" data-id="element-196" data-mp="1s5rrzqqp05oa">
                  You save ${SAVINGS} — 91% off
                </p>

                <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-197" data-mp="2kpgh4qoaf6xl">
                  One-time payment · Instant digital delivery
                </p>

                <CtaButton size="lg" fullWidth className="mt-8" data-id="element-198" data-mp="2o749cmd8856n">
                  Yes! I want a perfect dog for only $25
                </CtaButton>

                <p className="mt-4 text-center text-xs text-muted" data-id="element-199" data-mp="2x5g9pg3wahca">
                  Covered by our 30-day “Happy Tail” guarantee.
                </p>

                <ul className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 border-t border-line pt-6 text-[10px] font-medium text-muted sm:gap-x-5 sm:text-[11px]" data-id="element-200" data-mp="326dqbo99b3bo">
                  <li className="flex items-center gap-2" data-id="element-201" data-mp="3b4pfdluh5t20">
                    <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-202" data-mp="3fwqx3naewbzf" />
                    <span data-id="element-203" data-mp="3fyk3d1h44u6w">Secure SSL encryption</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-204" data-mp="3kv27bz4mcoi6">
                    <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-205" data-mp="3pv6ntp5j1j8e" />
                    <span data-id="element-206" data-mp="3psu0ewh02gny">Instant access</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-207" data-mp="3uu9m8qr04r7e">
                    <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-208" data-mp="354t0lmry3qzc" />
                    <span data-id="element-209" data-mp="306rhj1uirrnv">Card · Google Pay · Apple Pay</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}